/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { DOMAttributes } from 'react';
import { IconPrefix, IconName } from '@fortawesome/pro-solid-svg-icons';
import { Tooltip } from 'antd';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';

import { EStyle } from '../../../types';
import { useStyles } from '~src/hooks/useStyles';
import { styleFn } from './IconButton.style';

export interface IconButtonProps {
  iconStyle?: IconPrefix;
  iconSecond?: IconName | FontAwesomeIconProps['icon'] | null;
  icon?: IconName | FontAwesomeIconProps['icon'] | null;
  customStyle?: EStyle;
  customStyleSecondIcon?: EStyle;
  containerStyle?: EStyle;
  tooltip?: any;
  backgroundOff?: boolean;
  click?: DOMAttributes<HTMLDivElement>['onClick'];
  color?: string;
  colorSecondIcon?: string;
  disabled?: boolean;
  badge?: string;
  badgeStyle?: EStyle;
  textStyle?: EStyle;
  widthTooltip?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  iconStyle = 'far',
  icon,
  iconSecond,
  customStyle,
  customStyleSecondIcon,
  containerStyle,
  tooltip,
  backgroundOff,
  click,
  color,
  colorSecondIcon,
  disabled,
  badge,
  badgeStyle,
  widthTooltip = '',
}) => {
  const style = useStyles(styleFn);

  const styled = color ? [customStyle, style[color]] : [customStyle];
  const styledSecondIcon = colorSecondIcon
    ? [customStyleSecondIcon, style[colorSecondIcon]]
    : [customStyleSecondIcon];

  return (
    <div
      css={[
        style.container,
        !backgroundOff && !disabled && style.containerWithHover,
        disabled && style.containerDisabled,
        containerStyle,
      ]}
      onClick={!disabled ? click : undefined}
      role="button"
      tabIndex={0}>
      <Tooltip
        overlayStyle={{ maxWidth: widthTooltip, width: widthTooltip }}
        placement="bottom"
        title={tooltip}>
        <div css={{ position: 'relative' }}>
          {icon && (
            <FontAwesomeIcon
              // /style={{ color: '#82510d' }}
              //color={['#82510d', '#2c6196']}
              icon={Array.isArray(icon) ? icon : [iconStyle, icon as IconName]}
              css={[...styled, disabled && { color: 'lightgray' }]}
              className={!color ? 'dark-mode-turn-to-white' : ''}
            />
          )}
          {iconSecond && (
            <FontAwesomeIcon
              icon={
                Array.isArray(iconSecond)
                  ? iconSecond
                  : [iconStyle, iconSecond as IconName]
              }
              css={[
                ...styledSecondIcon,

                disabled && { color: 'lightgray' },
                {
                  position: 'absolute',
                  fontSize: '15px',
                },
              ]}
              className={!color ? 'dark-mode-turn-to-white' : ''}
            />
          )}
          {badge && (
            <div css={[style.badgeContainer, badgeStyle && badgeStyle]}>
              {badge}
            </div>
          )}
        </div>
      </Tooltip>
    </div>
  );
};

export default IconButton;
